import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { LayoutComponent } from './components/layout/layout.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { SafePipe } from './pipes/safe.pipe';
import { AttachmentViewerComponent } from './components/attachment-viewer/attachment-viewer.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { NotificationsComponent } from './components/notifications/notifications.component';


@NgModule({
  declarations: [
    SidebarComponent,
    TopbarComponent,
    LayoutComponent,
    CalculatorComponent,
    SafePipe,
    AttachmentViewerComponent,
    UnauthorizedComponent,
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule
  ],
  exports:[
    LayoutComponent,
    CalculatorComponent,
    SafePipe,
    AttachmentViewerComponent
  ]
})
export class SharedModule { }
